import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/funnelChart";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
export function ContactMethodFilter() {
  const dispatch = useDispatch();

  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);
  const selected = useSelector((state) => state.laser.selectedFilters.contactMethodFilters);
  const options = useSelector((state) => state.laser.contactMethodOptions);

  return startFrom === "leads" ? (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">First Contact Method</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selected}
        numberDisplayed={0}
        includeSelectAll
        enableOnly
        includeFilter={false}
        onSelectChange={(data) => dispatch(actionCreators.setContactMethodFilters(data))}
      />
    </div>
  ) : null;
}
